import axios from "@/api/config";

const videoMaterials = {
  addVideoMaterials(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoMaterials/addVideoMaterials`,
      data
    );
  },
  changeSort(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoMaterials/changeSort`,
      data
    );
  },
  getVideoMaterials(data) {
    return axios.get(
      `${process.env.BASE_URL}/videoMaterials/getVideoMaterials`,
      {
        params: data
      }
    );
  },
  // 课堂教学 上传视频
  addAttachmentRecording(data) {
    return axios.post(
      `${process.env.BASE_URL}/attachmentObject/addAttachmentRecording`,
      data
    );
  },
  // 课堂教学 获取视频
  recordingPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/attachmentObject/recordingPageList`,
      data
    );
  },
  // 课堂教学 删除视频
  deleteAttachmentRecording(data) {
    return axios.post(
      `${process.env.BASE_URL}/attachmentObject/deleteAttachmentRecording`,
      data
    );
  },
  // 课堂教学 更新视频名称视频
  updateAttachment(data) {
    return axios.post(
      `${process.env.BASE_URL}/attachment/updateAttachment`,
      data
    );
  },

  addBatchVideoMaterials(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoMaterials/addBatchVideoMaterials`,
      data
    );
  },

  addVideoMaterialsRelation(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideoRelation/addVideoMaterialsRelation`,
      data
    );
  }
};

export default videoMaterials;



// WEBPACK FOOTER //
// ./src/api/videoMaterials.js